import { render, staticRenderFns } from "./promote-detail.vue?vue&type=template&id=3fead2e3&scoped=true&"
import script from "./promote-detail.vue?vue&type=script&lang=js&"
export * from "./promote-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fead2e3",
  null
  
)

export default component.exports